// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FrequencyByFaultResponse implements flatbuffers.IUnpackableObject<FrequencyByFaultResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrequencyByFaultResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrequencyByFaultResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FrequencyByFaultResponse,
  ): FrequencyByFaultResponse {
    return (obj || new FrequencyByFaultResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFrequencyByFaultResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FrequencyByFaultResponse,
  ): FrequencyByFaultResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrequencyByFaultResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fault(): string;
  fault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  fault(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  detailedFault(): string;
  detailedFault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  detailedFault(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  total(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  totalCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  frequency(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startFrequencyByFaultResponse(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addFault(builder: flatbuffers.Builder, faultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, faultOffset, 0);
  }

  static addDetailedFault(builder: flatbuffers.Builder, detailedFaultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, detailedFaultOffset, 0);
  }

  static addTotal(builder: flatbuffers.Builder, total: number) {
    builder.addFieldInt32(4, total, 0);
  }

  static addTotalCount(builder: flatbuffers.Builder, totalCount: number) {
    builder.addFieldInt32(5, totalCount, 0);
  }

  static addFrequency(builder: flatbuffers.Builder, frequency: number) {
    builder.addFieldInt32(6, frequency, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(7, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(8, liftId, 0);
  }

  static endFrequencyByFaultResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // fault
    builder.requiredField(offset, 10); // detailed_fault
    return offset;
  }

  static createFrequencyByFaultResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    faultOffset: flatbuffers.Offset,
    detailedFaultOffset: flatbuffers.Offset,
    total: number,
    totalCount: number,
    frequency: number,
    bankId: number,
    liftId: number,
  ): flatbuffers.Offset {
    FrequencyByFaultResponse.startFrequencyByFaultResponse(builder);
    FrequencyByFaultResponse.addBankName(builder, bankNameOffset);
    FrequencyByFaultResponse.addLiftName(builder, liftNameOffset);
    FrequencyByFaultResponse.addFault(builder, faultOffset);
    FrequencyByFaultResponse.addDetailedFault(builder, detailedFaultOffset);
    FrequencyByFaultResponse.addTotal(builder, total);
    FrequencyByFaultResponse.addTotalCount(builder, totalCount);
    FrequencyByFaultResponse.addFrequency(builder, frequency);
    FrequencyByFaultResponse.addBankId(builder, bankId);
    FrequencyByFaultResponse.addLiftId(builder, liftId);
    return FrequencyByFaultResponse.endFrequencyByFaultResponse(builder);
  }

  unpack(): FrequencyByFaultResponseT {
    return new FrequencyByFaultResponseT(
      this.bankName(),
      this.liftName(),
      this.fault(),
      this.detailedFault(),
      this.total(),
      this.totalCount(),
      this.frequency(),
      this.bankId(),
      this.liftId(),
    );
  }

  unpackTo(_o: FrequencyByFaultResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.fault = this.fault();
    _o.detailedFault = this.detailedFault();
    _o.total = this.total();
    _o.totalCount = this.totalCount();
    _o.frequency = this.frequency();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): FrequencyByFaultResponseT {
    const t = new FrequencyByFaultResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("fault")) {
      t.fault = this.fault();
    }
    if (fieldSet.has("detailed_fault")) {
      t.detailedFault = this.detailedFault();
    }
    if (fieldSet.has("total")) {
      t.total = this.total();
    }
    if (fieldSet.has("total_count")) {
      t.totalCount = this.totalCount();
    }
    if (fieldSet.has("frequency")) {
      t.frequency = this.frequency();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class FrequencyByFaultResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public fault: string | Uint8Array | null = null,
    public detailedFault: string | Uint8Array | null = null,
    public total: number = 0,
    public totalCount: number = 0,
    public frequency: number = 0,
    public bankId: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fault === null || this.fault === undefined) {
      throw new Error('Required field "fault" is not set');
    }
    if (this.detailedFault === null || this.detailedFault === undefined) {
      throw new Error('Required field "detailed_fault" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const fault = this.fault !== null ? builder.createString(this.fault!) : 0;
    const detailedFault =
      this.detailedFault !== null ? builder.createString(this.detailedFault!) : 0;

    return FrequencyByFaultResponse.createFrequencyByFaultResponse(
      builder,
      bankName,
      liftName,
      fault,
      detailedFault,
      this.total,
      this.totalCount,
      this.frequency,
      this.bankId,
      this.liftId,
    );
  }

  clone(): FrequencyByFaultResponseT {
    const obj = new FrequencyByFaultResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.fault = this.fault;
    obj.detailedFault = this.detailedFault;
    obj.total = this.total;
    obj.totalCount = this.totalCount;
    obj.frequency = this.frequency;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: FrequencyByFaultResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.fault !== other.fault) return false;
    if (this.detailedFault !== other.detailedFault) return false;
    if (this.total !== other.total) return false;
    if (this.totalCount !== other.totalCount) return false;
    if (this.frequency !== other.frequency) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyFrequencyByFaultResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "fault");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "detailed_fault");
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
  } finally {
    verifier.popDepth();
  }
}
